import React, { useState, useEffect, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  IconButton,
  TextField,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GetAppIcon from "@mui/icons-material/GetApp";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { URL } from "../config";
import { useOutletContext } from "react-router-dom";

const CustomerList = () => {
  const { setLoading } = useOutletContext();
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");

 
  const fetchCustomers = async () => {
    setLoading(true); 
    try {
      const res = await axios.get(`${URL}/customers`);
      setDataSource(res.data || []);
    } catch (err) {
      console.error("Error fetching customers:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCustomers(); 
  }, []);



 const handleDownloadExcel = async () => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Customer List");

    worksheet.columns = [
      { header: "Customer ID", key: "CustomerId", width: 12 },
      { header: "Customer Name", key: "CustomerName", width: 30 },
      { header: "Mobile No", key: "MobileNo", width: 18 },
      { header: "Alternate Mobile", key: "alternateMobileNo", width: 18 },
      { header: "Address", key: "Address", width: 40 },
      { header: "Shop Name", key: "ShopName", width: 25 },
      { header: "Pincode", key: "Pincode", width: 12 },
      { header: "Latitude", key: "Latitude", width: 15 },
      { header: "Longitude", key: "Longitude", width: 15 },
      { header: "Internet", key: "Internet", width: 12 },
      { header: "Monitoring", key: "Monitoring", width: 12 },
      { header: "Camera Count", key: "CountOfCamera", width: 15 },
      { header: "Service Duration", key: "serviceDuration", width: 18 },
      { header: "Service Status", key: "isServiceActive", width: 15 },
      { header: "Description", key: "description", width: 40 },
    ];

    dataSource.forEach(item => {
      worksheet.addRow({
        CustomerId: item.CustomerId,
        CustomerName: item.CustomerName || "N/A",
        MobileNo: item.MobileNo || "N/A",
        alternateMobileNo: item.alternateMobileNo || "N/A",
        Address: item.Address || "",
        ShopName: item.ShopName || "",
        Pincode: item.Pincode || "",
        Latitude: item.Latitude || "",
        Longitude: item.Longitude || "",
        Internet: item.Internet === 1 ? "Yes" : "No",
        Monitoring: item.Monitoring === 1 ? "Yes" : "No",
        CountOfCamera: item.CountOfCamera || 0,
        serviceDuration: item.serviceDuration || "-",
        isServiceActive: item.isServiceActive === 1 ? "Active" : "Inactive",
        description: item.description || "",
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "Customer_List.xlsx");
  } catch (err) {
    console.error("Excel export error:", err);
  }
};
const handleDownloadPDF = () => {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

  doc.setFontSize(18);
  doc.text("Customer List", 40, 40);

  const head = [[
    "ID",
    "Name",
    "Mobile",
    "Alt Mobile",
    "Address",
    "Shop",
    "Pincode",
    "Lat",
    "Long",
    "Internet",
    "Monitoring",
    "Cameras",
    "Service Duration",
    "Status",
    "Description",
  ]];

  const body = dataSource.map(item => ([
    item.CustomerId,
    item.CustomerName || "N/A",
    item.MobileNo || "N/A",
    item.alternateMobileNo || "N/A",
    item.Address || "",
    item.ShopName || "",
    item.Pincode || "",
    item.Latitude || "",
    item.Longitude || "",
    item.Internet === 1 ? "Yes" : "No",
    item.Monitoring === 1 ? "Yes" : "No",
    item.CountOfCamera || 0,
    item.serviceDuration || "-",
    item.isServiceActive === 1 ? "Active" : "Inactive",
    item.description || "",
  ]));

  autoTable(doc, {
    startY: 60,
    head,
    body,
    theme: "grid",
    styles: { fontSize: 9, cellPadding: 5 },
    headStyles: { fillColor: [23, 66, 83], textColor: "#fff" },
  });

  doc.save("Customer_List.pdf");
};
const handlePrint = () => {
  const tableRows = dataSource.map((item) => `
    <tr>
      <td>${item.CustomerId}</td>
      <td>${item.CustomerName || "N/A"}</td>
      <td>${item.MobileNo || "N/A"}</td>
      <td>${item.alternateMobileNo || "N/A"}</td>
      <td>${item.Address || ""}</td>
      <td>${item.ShopName || ""}</td>
      <td>${item.Pincode || ""}</td>
      <td>${item.Latitude || ""}</td>
      <td>${item.Longitude || ""}</td>
    </tr>
  `).join("");

  const style = `
    <style>
      @media print {
        @page { size: landscape; margin: 18mm; }
        body { -webkit-print-color-adjust: exact !important; }
      }

      table {
        width:100%;
        border-collapse: collapse;
        font-size:14px;
      }

      th {
        background:#174253;
        color:#fff;
        padding:10px;
        text-align:left;
        border-bottom:2px solid #174253;
      }

      td {
        padding:10px;
        border-top:1px solid #dcdcdc;
        border-bottom:1px solid #dcdcdc;
      }

      tr:nth-child(even) td {
        background:#f5f5f5;
      }

      h1 {
        text-align:center;
        color:#174253;
        margin-bottom:20px;
        font-size:22px;
      }
    </style>
  `;

  const html = `
    <html>
      <head>
        <title>Customer List</title>
        ${style}
      </head>
      <body>
        <h1>Customer List</h1>
        <table>
          <thead>
            <tr>
              <th>Customer ID</th>
              <th>Customer Name</th>
              <th>Mobile No</th>
              <th>Alternate Mobile</th>
              <th>Address</th>
              <th>Shop Name</th>
              <th>Pincode</th>
              <th>Latitude</th>
              <th>Longitude</th>
            </tr>
          </thead>
          <tbody>
            ${tableRows}
          </tbody>
        </table>
      </body>
    </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(html);
  printWindow.document.close();
  setTimeout(() => printWindow.print(), 500);
};

const columns = useMemo(() => [
  { accessorKey: "CustomerId", header: "ID", size: 70 },
  { accessorKey: "CustomerName", header: "Customer Name", size: 180 },
  { accessorKey: "MobileNo", header: "Mobile", size: 140 },
  { accessorKey: "alternateMobileNo", header: "Alt Mobile", size: 140 },
  { accessorKey: "Address", header: "Address", size: 220 },
  { accessorKey: "ShopName", header: "Shop Name", size: 160 },
  { accessorKey: "Pincode", header: "Pincode", size: 100 },
  { accessorKey: "Latitude", header: "Latitude", size: 120 },
  { accessorKey: "Longitude", header: "Longitude", size: 120 },
  {
    accessorKey: "Internet",
    header: "Internet",
    size: 100,
    Cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
  },
  {
    accessorKey: "Monitoring",
    header: "Monitoring",
    size: 120,
    Cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
  },
  { accessorKey: "CountOfCamera", header: "Cameras", size: 100 },
  { accessorKey: "serviceDuration", header: "Service Duration", size: 160 },
  {
    accessorKey: "isServiceActive",
    header: "Status",
    size: 120,
    Cell: ({ cell }) => (cell.getValue() === 1 ? "Active" : "Inactive"),
  },
], []);


  return (
    <Box sx={{ width: "100%", bgcolor: "#ffffff", marginTop:"20px", p: { xs: 1, md: 0 }, overflow: "hidden" }}>
      
      <Box sx={{ fontWeight: 700, fontSize: "22px", color: "#174253", letterSpacing: 0.5, borderLeft: "5px solid #174253", paddingLeft: "12px", marginBottom:"20px" }}>
        Customer List
      </Box>

      <Box sx={{ background: "#fff", borderRadius: "0 0 15px 15px" }}>
        <div style={{ position: "relative", width: "100%", marginTop:"10px" }}>
          <div style={{ position: "absolute", top: "10px", right: "20px", left: "20px", display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 2, marginBottom: "10px" }}>
            
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Tooltip title="Download Excel">
                <IconButton onClick={handleDownloadExcel} sx={{ backgroundColor: "#d4f1d4", color: "#174253", "&:hover": { backgroundColor: "#b5e3b5" } }}>
                  <GetAppIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Download PDF">
                <IconButton onClick={handleDownloadPDF} sx={{ backgroundColor: "#ffe2e2", color: "#d32f2f", "&:hover": { backgroundColor: "#ffcccc" } }}>
                  <PictureAsPdfIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Print">
                <IconButton onClick={handlePrint} sx={{ backgroundColor: "#e3f2fd", color: "#174253", "&:hover": { backgroundColor: "#cde4fa" } }}>
                  <PrintIcon />
                </IconButton>
              </Tooltip>
            </div>

            
            <TextField
              size="small"
              placeholder="Search customers..."
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: "#174253" }} /></InputAdornment> }}
              sx={{ width: { xs: "200px", sm: "250px" }, "& .MuiOutlinedInput-root": { borderRadius: "25px", height: "38px", backgroundColor: "#fff", boxShadow: "0 0 6px rgba(0,0,0,0.1)", "& fieldset": { borderColor: "#d0d7de" }, "&:hover fieldset": { borderColor: "#174253" } } }}
            />
          </div>
        </div>

        <MaterialReactTable
  columns={columns}
  data={
    [...dataSource] 
      .reverse()    
      .filter(item =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(globalFilter.toLowerCase())
      )
  }

  enablePagination={true}

  initialState={{
    pagination: {
      pageSize: 100,   
      pageIndex: 0,
    },
  }}

  muiPaginationProps={{
    rowsPerPageOptions: [10, 25, 50, 100], 
    showFirstButton: true,
    showLastButton: true,
  }}

  enableColumnActions={false}
  enableDensityToggle={false}
  enableFullScreenToggle={false}
  enableColumnFilters={false}
  enableHiding={false}
  enableGlobalFilter={false}

  muiTablePaperProps={{
    sx: {
      boxShadow: "none",
      background: "#fff",
      borderRadius: "15px",
    },
  }}

  muiTableContainerProps={{
    sx: {
      backgroundColor: "#fff",
      width: "100%",
      overflowX: "auto",
      borderRadius: "12px",
      "&::-webkit-scrollbar": { height: "6px" },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#e0e3ea",
        borderRadius: "10px",
      },
    },
  }}

  muiTableHeadCellProps={{
    sx: {
      backgroundColor: "#e0e0e0ff",
      color: "#393e4f",
      fontWeight: 600,
      fontSize: "16px",
      borderBottom: "0.5px solid #e3e5eb",
      textAlign: "left",
      height: "63px",
      paddingTop: "23px",
    },
  }}

  muiTableBodyRowProps={({ row }) => ({
    onClick: () => {
      navigate(`/dashboard/customers/${row.original.CustomerId}`);
    },
    sx: {
      cursor: "pointer",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "#e3f2fd",
      },
      "& td": {
        fontSize: { xs: "12px", sm: "14px" },
        p: "8px",
        borderBottom: "0.5px solid #e3e5eb",
        height: "54px",
      },
    },
  })}
/>

      </Box>
    </Box>
  );
};

export default CustomerList;
